// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grid template */

  .profile-actions {
    grid-area: profile-actions;
  }

  .profile-form {
    grid-area: profile-form;
  }

  .profile-fields {
    grid-area: profile-fields;
  }


/* Profile actions */

.profile-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.profile-actions button {
  border-radius: 0;
  background: #FBEAD3;
  border: 2px solid black;
  cursor: pointer;
}

.profile-actions .message-user button, .profile-actions .back-button button, .edit-user button, .dropdown button {
  padding: 7px 22px;
  font-weight: 700;
}

.message-user button {
  text-transform: uppercase;
}

/* Profile fields */

.profile-group {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2%;
  overflow: hidden;
}

.profile-key input {
  max-width: 75%;
}

.profile fieldset {
  margin-bottom: 25px;
}

.profile textarea {
  width: 90%;
  min-height: 100px;
}

.profile input[type=submit] {
  margin-bottom: 30px;
}

.online-status {
  background: lightgreen;
  max-height: 15px;
  max-width: 10px;
}

/* Fields */

span.pronoun-user-view {
  display: inline-block;
  min-width: 80px;
  color: #1f1f1f;
  background: #FBEAD3;
  border-radius: 30px;
  padding: 10px 20px;
  border: 1px solid black;
}

.details-meeting {
  margin-top: 20px;
}

.bold {
  font-size: 1.2em;
}

.badge {
  padding-right: 10px;
  color: #f7f7f7;
}

button[type=submit] {
  cursor: pointer;
  padding: 7px 15px;
  margin-bottom: 10px;
  border-radius: 30px;
  border: 0;
  background-color: #FBEAD3;
  font-family: "Aileron-SemiBold";
}

button[type=submit] {
  min-width: 180px;
}

/* Profile photos */

.profile-photos {
  margin-bottom: 20px;
}

/* Large main image swiper */
.mySwiper2 {
  width: 100%;
  margin-bottom: 10px;
  overflow: hidden;
}

@media screen and (min-width: 768px) {
  .mySwiper2 {
    height: 400px;
  }
}

/* Thumbnail swiper */
.mySwiper {
  height: 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.mySwiper .swiper-slide {
  width: 100px !important;
  height: 100px;
  opacity: 0.4;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
  border-color: #333;
}

.mySwiper img,
.mySwiper2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper, .swiper-wrapper {
}

/* Desktop */

@media screen and (min-width: 1028px) {

  .profile .main {
    max-width: 80%;
  }

  .profile .content {
    padding-top: 10vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-template-areas: 
      "profile-actions ."
      "profile-form profile-form";
  }

  .profile-actions {
    width: 94%;
  }

  .profile-form {
    display: grid;
    grid-template-columns: 47% 47%;
    grid-template-rows: auto;
    grid-template-areas: 
      "profile-photos profile-fields";
    gap: 2%;
  }

  .profile-group {
    flex-direction: row;
  }

  .profile select {
    min-width: 130px;
  }

  .profile textarea {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/profile.css"],"names":[],"mappings":"AAAA,kBAAkB;;EAEhB;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;;AAGF,oBAAoB;;AAEpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,kCAAkC;EAClC,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;;AAEX;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;AACA;;AAEA,YAAY;;AAEZ;;EAEE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;IACxB;;iCAE6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;IACxB;qCACiC;IACjC,OAAO;EACT;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Grid template */\n\n  .profile-actions {\n    grid-area: profile-actions;\n  }\n\n  .profile-form {\n    grid-area: profile-form;\n  }\n\n  .profile-fields {\n    grid-area: profile-fields;\n  }\n\n\n/* Profile actions */\n\n.profile-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.profile-actions button {\n  border-radius: 0;\n  background: #FBEAD3;\n  border: 2px solid black;\n  cursor: pointer;\n}\n\n.profile-actions .message-user button, .profile-actions .back-button button, .edit-user button, .dropdown button {\n  padding: 7px 22px;\n  font-weight: 700;\n}\n\n.message-user button {\n  text-transform: uppercase;\n}\n\n/* Profile fields */\n\n.profile-group {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 2%;\n  overflow: hidden;\n}\n\n.profile-key input {\n  max-width: 75%;\n}\n\n.profile fieldset {\n  margin-bottom: 25px;\n}\n\n.profile textarea {\n  width: 90%;\n  min-height: 100px;\n}\n\n.profile input[type=submit] {\n  margin-bottom: 30px;\n}\n\n.online-status {\n  background: lightgreen;\n  max-height: 15px;\n  max-width: 10px;\n}\n\n/* Fields */\n\nspan.pronoun-user-view {\n  display: inline-block;\n  min-width: 80px;\n  color: #1f1f1f;\n  background: #FBEAD3;\n  border-radius: 30px;\n  padding: 10px 20px;\n  border: 1px solid black;\n}\n\n.details-meeting {\n  margin-top: 20px;\n}\n\n.bold {\n  font-size: 1.2em;\n}\n\n.badge {\n  padding-right: 10px;\n  color: #f7f7f7;\n}\n\nbutton[type=submit] {\n  cursor: pointer;\n  padding: 7px 15px;\n  margin-bottom: 10px;\n  border-radius: 30px;\n  border: 0;\n  background-color: #FBEAD3;\n  font-family: \"Aileron-SemiBold\";\n}\n\nbutton[type=submit] {\n  min-width: 180px;\n}\n\n/* Profile photos */\n\n.profile-photos {\n  margin-bottom: 20px;\n}\n\n/* Large main image swiper */\n.mySwiper2 {\n  width: 100%;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n@media screen and (min-width: 768px) {\n  .mySwiper2 {\n    height: 400px;\n  }\n}\n\n/* Thumbnail swiper */\n.mySwiper {\n  height: 100px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.mySwiper .swiper-slide {\n  width: 100px !important;\n  height: 100px;\n  opacity: 0.4;\n  cursor: pointer;\n  transition: 0.3s ease-in-out;\n}\n\n.mySwiper .swiper-slide-thumb-active {\n  opacity: 1;\n  border-color: #333;\n}\n\n.mySwiper img,\n.mySwiper2 img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.swiper, .swiper-wrapper {\n}\n\n/* Desktop */\n\n@media screen and (min-width: 1028px) {\n\n  .profile .main {\n    max-width: 80%;\n  }\n\n  .profile .content {\n    padding-top: 10vh;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto;\n    grid-template-areas: \n      \"profile-actions .\"\n      \"profile-form profile-form\";\n  }\n\n  .profile-actions {\n    width: 94%;\n  }\n\n  .profile-form {\n    display: grid;\n    grid-template-columns: 47% 47%;\n    grid-template-rows: auto;\n    grid-template-areas: \n      \"profile-photos profile-fields\";\n    gap: 2%;\n  }\n\n  .profile-group {\n    flex-direction: row;\n  }\n\n  .profile select {\n    min-width: 130px;\n  }\n\n  .profile textarea {\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
